export type Variant = 'variant1' | 'variant2' | 'variant3';
export type SigningPersonId = 'lapaev' | 'vasyutin' | 'koreshin' | 'office';
export type GateSigningPersonId = 'arkhiptsev' | 'gordiychuk' | 'balashov' | 'office';
export type GatePaymentType = '50-50' | '50-40-10';
export type PaymentMethod = 'cash' | 'bank' | 'qr';

export interface ClientData {
  fullName: string;
  passportSeries: string;
  passportNumber: string;
  passportIssuedBy: string;
  passportIssuedDate: string;
  registeredAddress: string;
  actualAddress: string;
  phone: string;
  phoneSecondary: string;
  email: string;
}

export interface WindowsFields {
  contractNumber: string;
  contractDate: string;
  totalAmount: string;
  constructionsAmount: string;
  garbageRemovalAmount: string;
  slopesAmount: string;
  deliveryAmount: string;
  prepaymentAmount: string;
  prepaymentDueDate: string;
  paymentMethod: PaymentMethod;
  installationAddress: string;
  measurementDone: boolean;
  sizesBySeller: boolean;
  podryadPrepaymentMode: 'half' | 'none' | 'custom';
  podryadPrepaymentAmount: string;
  workDemontage: string;
  workInstallation: string;
  workSlopes: string;
  workFlashings: string;
  workAdditional: string;
}

export interface GateFields {
  contractNumber: string;
  contractDate: string;
  paymentType: GatePaymentType;
  totalAmount: string;
  prepaymentAmount: string;
  prepaymentDueDate: string;
  paymentMethod: PaymentMethod;
  installationAddress: string;
  measurementDone: boolean;
  sizesBySeller: boolean;
  productAmount: string;
  preparationMaterial: string;
  deliveryAmount: string;
  installationAmount: string;
  preparationWork: string;
  demontageAmount: string;
}

export interface Signatures {
  employee: string | null;
  /** Подпись представителя подрядчика — только variant2 + ОФИС (Федина Е.И.) */
  employeePodryad: string | null;
  windowsKp: string | null;
  windowsPodryad: string | null;
  gate: string | null;
}

export interface InsertFile {
  name: string;
  base64: string;
}

export interface WizardState {
  variant: Variant | null;
  signingPersonId: SigningPersonId;
  gateSigningPersonId: GateSigningPersonId;
  windows: WindowsFields;
  gate: GateFields;
  client: ClientData;
  signatures: Signatures;
  inserts: InsertFile[];
}

/** Максимальное число прикрепляемых файлов-вставок */
export const MAX_INSERTS = 5;

export type WizardStep =
  | 'variant'
  | 'yellow'
  | 'green'
  | 'review'
  | 'signatures'
  | 'insert'
  | 'summary';
